import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initializeGallery(galleryElement) {
    const swiperPagination = galleryElement.querySelector('.swiper-pagination');
    const id = galleryElement.getAttribute('id');
    new Swiper(galleryElement.querySelector('.swiper'), {
        modules: [Pagination, Navigation, Autoplay],
        slidesPerView: 1,
        loop: true,
        // autoplay: {
        //     delay: 10000,
        //     disableOnInteraction: false,
        // },
        pagination: {
            el: swiperPagination,
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next-' + id,
            prevEl: '.swiper-button-prev-' + id,
        },
        on: {
            slideChangeTransitionEnd() {
                changeCaptionWithSlide(galleryElement);
            },
        },
    });
}

function changeCaptionWithSlide(galleryElement) {
    const slider = galleryElement.querySelector('.swiper');
    const sliderWrapper = slider.querySelector('.swiper-wrapper');
    const sliderSlides = sliderWrapper.querySelectorAll('.swiper-slide');

    const caption = document.getElementById(`caption-${parseInt(slider.getAttribute('data-id'))}`);
    if (caption) {
        caption.style.display = 'none';

        if (slider.querySelector('.swiper-slide-active')) {
            const activeImageID = parseInt(slider.querySelector('.swiper-slide-active').getAttribute('data-id'));

            sliderSlides.forEach((slide) => {
                caption.style.display = parseInt(slide.getAttribute('data-id')) === activeImageID ? 'block' : 'none';
            });
        }
    }
}

function initializeAllGalleries() {
    document.querySelectorAll('.gallery').forEach(function (element) {
        initializeGallery(element);
        changeCaptionWithSlide(element);
    });
}

domContentLoadEvent(initializeAllGalleries);
